import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgExecutePhase = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M7 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m6-3.45a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zm0 7.7a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zM7 17.4a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8M7 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgExecutePhase);
export default ForwardRef;
